<template>
    <div class="termly-policy-container">
        <div name="termly-embed" :data-id="termlyDataId" data-type="iframe"></div>
    </div>
</template>

<script>
export default {
    name: 'TermlyPolicy',
    props: ['termlyDataId'],
    data() {
        return {};
    },
    mounted() {
        // This hook runs after the component has been mounted to the DOM
        this.loadTermlyScript();
    },
    methods: {
        loadTermlyScript() {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://app.termly.io/embed-policy.min.js';
            script.async = true;

            // Append the script to the body or the component's root element
            document.body.appendChild(script);
        }
    }
};
</script>

<style scoped>
/* Optional: Add styles to control the appearance of the embedded policy */
.termly-policy-container {
    padding: 20px;
    color: #FFFFFF;
}
</style>
